<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="location_id detail_content">
            <div class="location_id_label detail_label">
              {{ userIdLabel }}
            </div>
            {{ location.userId }}
          </div>
          <div class="pronunciation detail_content">
            <div class="pronunciation_label detail_label">
              {{ pronunciationLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="location.pronunciation"
              @input="inputUpdate('pronunciation')"
            />
          </div>
          <div class="location_name detail_content">
            <div class="location_name_label detail_label">
              {{ userNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="location.userName"
              @input="inputUpdate('userName')"
            />
          </div>
          <div class="phone_number detail_content">
            <div class="phone_number_label detail_label">
              {{ phoneNumberLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="location.phoneNumber"
              @input="inputUpdate('phoneNumber')"
            />
          </div>
          <div class="location_address detail_content">
            <div class="location_address_label detail_label">
              {{ locationAddressLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="location.locationAddress"
              @input="inputUpdate('locationAddress')"
            />
          </div>
          <div class="memo_detail_content">
            <div class="memo_label detail_label">
              {{ memoLabel }}
            </div>
            <textarea
              class="detail_input_field memo"
              type="text"
              v-model="location.memo"
              @input="inputUpdate('memo')"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showModal = true"
        />
      </div>
      <div class="modalWindow" v-if="showModal">
        <modalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </modalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import modalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      userIdLabel: '拠点ID',
      pronunciationLabel: 'ふりがな',
      userNameLabel: '拠点名',
      postNameLabel: '所属名',
      phoneNumberLabel: '電話番号',
      locationAddressLabel: '住所',
      memoLabel: '補足情報',
      router: '/places',
      deleteWord: 'この情報を削除してよろしいですか？',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    location() {
      return this.$store.state.places.location
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  components: {
    modalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('places/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'places/setDetailLocation',
          this.$store.state.places.location
        )
        this.$router.push('../places/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_190001
        let eventType = 3
        let reason = 'MSGCRC0028 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0028.name +
            this.errorMsg.MSGCRC0028.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('places/updateLocation')
        this.$emit('list-reload')
        if (location.pathname !== '/places/detail') {
          this.$router.push('../places/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_190003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0023') {
            this.failureWord =
              this.errorMsg.MSGCRC0023.name +
              this.errorMsg.MSGCRC0023.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0024') {
            this.failureWord =
              this.errorMsg.MSGCRC0024.name +
              this.errorMsg.MSGCRC0024.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0092') {
            this.failureWord =
              this.errorMsg.MSGCRC0092.name +
              this.errorMsg.MSGCRC0092.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0098') {
            this.failureWord =
              this.errorMsg.MSGCRC0098.name +
              this.errorMsg.MSGCRC0098.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0099') {
            this.failureWord =
              this.errorMsg.MSGCRC0099.name +
              this.errorMsg.MSGCRC0099.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0100') {
            this.failureWord =
              this.errorMsg.MSGCRC0100.name +
              this.errorMsg.MSGCRC0100.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0122') {
            this.failureWord =
              this.errorMsg.MSGCRC0122.name +
              this.errorMsg.MSGCRC0122.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0124') {
            this.failureWord =
              this.errorMsg.MSGCRC0124.name +
              this.errorMsg.MSGCRC0124.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0206') {
            this.failureWord =
              this.errorMsg.MSGCRC0206.name +
              this.errorMsg.MSGCRC0206.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0273') {
            this.failureWord =
              this.errorMsg.MSGCRC0273.name +
              this.errorMsg.MSGCRC0273.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0028.name +
              this.errorMsg.MSGCRC0028.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'places/setDetailLocation',
          this.$store.state.places.location
        )
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_190002
        let eventType = 3
        let reason = 'MSGCRC0028 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0028.name +
            this.errorMsg.MSGCRC0028.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let userId = this.$store.state.places.location.userId
      let deviceId = this.$store.state.places.location.deviceId
      let deleteList = [{userId, deviceId}]
      try {
        await this.$store.dispatch('places/deleteLocations', deleteList)
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_190004
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0030') {
            this.failureWord =
              this.errorMsg.MSGCRC0030.name +
              this.errorMsg.MSGCRC0030.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0298') {
            this.failureWord =
              this.errorMsg.MSGCRC0298.name +
              this.errorMsg.MSGCRC0298.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0030'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0030.name +
            this.errorMsg.MSGCRC0030.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scope>
.memo {
  resize: vertical;
  min-height: 200px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/places/placeEdit.vue